import LifeIdScroller from './life-id-scroller';

export default LifeIdScroller;
